import React, { useEffect } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import Button from "components/Elements/Button/Button";
import './ErrorModals.scss'
import { LinkToNewTab } from "components/Elements/Link/Link.js";

const NotBusinessSubUsersModal = ({ typeOfModal = null }) => {

    const { getTextByKey, getHtmlByKey } = useContent();

    return (
        <div className="this-feature-not-availabe-modal-wrapper">
            <div className="title">
                {getTextByKey("this-feature-not-availabe-title")}
            </div>
            <div className="text">
                {getHtmlByKey("this-feature-not-availabe-text")}
            </div>
            <LinkToNewTab page={"purchase/business/yearly"} isNewTab={true}>
                <Button  medium>
                {getTextByKey("upgrade-to-business")}
                </Button>
            </LinkToNewTab>
        </div>
    )

}

export default NotBusinessSubUsersModal;